import * as fromRoot from '../../reducers';
import * as ScoringReducer from './scoring.reducer';
import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

export interface ScoringState {
  scoring: ScoringReducer.State;
}

export interface State extends fromRoot.State {
  scoringState: ScoringState;
}

export const reducers: ActionReducerMap<ScoringState, Action> = {
  scoring: ScoringReducer.reducer,
};
export const selectScoring = createFeatureSelector<State, ScoringState>('scoringState');

export const selectScoringState = createSelector(selectScoring, (state: ScoringState) => state.scoring);

export const getDates = createSelector(selectScoringState, ScoringReducer.getDates);
export const getRankingData = createSelector(selectScoringState, ScoringReducer.getRankingData);
export const getRankingDataByRank = createSelector(selectScoringState, ScoringReducer.getRankingDataByRank);
export const getVehicleSummary = createSelector(selectScoringState, ScoringReducer.getVehicleSummary);
export const getVehiclePeriodStats = createSelector(selectScoringState, ScoringReducer.getVehiclePeriodStats);
export const hasError = createSelector(selectScoringState, ScoringReducer.hasError);
export const getDriver = createSelector(selectScoringState, ScoringReducer.getDriver);
export const getDriverList = createSelector(selectScoringState, ScoringReducer.getDriverList);
export const getDriverPeriodStats = createSelector(selectScoringState, ScoringReducer.getDriverPeriodStats);
export const getDriverSummary = createSelector(selectScoringState, ScoringReducer.getDriverSummary);
export const getSelectedDriverPeriodStats = createSelector(selectScoringState, ScoringReducer.getSelectedDriverPeriodStats);
export const getSelectedDriverSummary = createSelector(selectScoringState, ScoringReducer.getSelectedDriverSummary);
export const getGroupPeriodStats = createSelector(selectScoringState, ScoringReducer.getGroupPeriodStats);
export const getGroupSummary = createSelector(selectScoringState, ScoringReducer.getGroupSummary);
export const getIsSummaryLoading = createSelector(selectScoringState, ScoringReducer.getIsSummaryLoading);
export const getIsPeriodsChartLoading = createSelector(selectScoringState, ScoringReducer.getIsPeriodsChartLoading);
export const getIsDriversRankingLoading = createSelector(selectScoringState, ScoringReducer.getIsDriversRankingLoading);
export const getIsGroupsRankingLoading = createSelector(selectScoringState, ScoringReducer.getIsGroupsRankingLoading);
export const getIsVehiclesRankingLoading = createSelector(selectScoringState, ScoringReducer.getIsVehiclesRankingLoading);


